import React from "react";
import { Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Box, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import RestoreIcon from "@mui/icons-material/Restore";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { GetAllFilesAndFoldersByUserDto } from "../../types/FolderPermission";
import { GLOBALMESSAGES, MULTIPLE_FILE_EXISTS, RECYCLEMESSAGES, SINGLE_FILE_EXISTS } from "../../constants/messages";

interface FileReplacerProps{
    open: boolean;
    onClose: () => void;
    currentRow :GetAllFilesAndFoldersByUserDto;
    handleRestore:(isSkip: boolean,row: GetAllFilesAndFoldersByUserDto) => void;
    fileCount: number;
    fileName: string;
}
 
const FileReplacer: React.FC<FileReplacerProps> = ({open, onClose, currentRow, 
  handleRestore, fileCount, fileName }) => {

  const handleReplace = async() => {
    handleRestore(false, currentRow);
  };

  const handleSkip = async() => {
    handleRestore(true, currentRow);
  };

  return (
        <Dialog open={open} onClose={onClose}>
          <DialogTitle id="customized-dialog-title">{RECYCLEMESSAGES.REPLACESKIP_TITLE}</DialogTitle>
          <IconButton
      aria-label={GLOBALMESSAGES.Close}
      onClick={onClose}
      sx={() => ({
        position: "absolute",
        right: 8,
        top: 8,
        color: "#fff",
      })}
    >
        <CloseIcon />
      </IconButton>

          <DialogContent dividers>
            <Typography>{fileCount > 1 ? MULTIPLE_FILE_EXISTS(fileCount) : SINGLE_FILE_EXISTS(fileName)}</Typography>
          </DialogContent>
          <DialogActions>
            <Box display="flex" flexDirection="column" width="100%">
            <Button onClick={handleReplace} color="primary" startIcon={<RestoreIcon />}
             sx={{
              boxShadow: 1,
              bgcolor: "primary.light", 
              color: "white",
              "&:hover": {
                bgcolor: "primary.main",
              },
              mb: 1,
            }}
            >{fileCount > 1 ? RECYCLEMESSAGES.MULTIPLE_REPLACE : RECYCLEMESSAGES.SINGLE_REPLACE}</Button>
            <Button onClick={handleSkip} color="secondary" startIcon={<SkipNextIcon />}>{fileCount > 1 ? RECYCLEMESSAGES.MULTIPLE_SKIP : RECYCLEMESSAGES.SINGLE_SKIP}</Button>
            </Box>
          </DialogActions>
        </Dialog>
  );
};

export default FileReplacer;
